// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInExistingAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInExistingAccount";
import { fontConfig } from "@vanmeter/XDL/constants";
import { css } from "styled-components";

signInExistingAccountStyles.signInGridContainer = {
    gap: 16,
};

signInExistingAccountStyles.signInButtonGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
        &&& {
            margin-top: 4px;
        }
    `,
};

signInExistingAccountStyles.forgotPasswordLink = {
    typographyProps: {
        ...fontConfig.xSmallSingleLine,
        weight: fontConfig.weight.bold,
    },
};

signInExistingAccountStyles.resetPasswordModal = {
    sizeVariant: "small",
};
signInExistingAccountStyles.icon = {
    css: css`
        & > svg {
            width: 16px;
            height: 14px;
        }
    `,
};
